import React, { useEffect, useState } from 'react'
import { CButton, Loading } from '../../Components';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import AdminNavbar from '../Navbar/AdminNavbar';
import { Button, Form, InputGroup } from 'react-bootstrap';
import MakePagination from '../../Components/MakePagination';
import { urlPrefix } from '../../Helpers/Common';
import { adminRemoveDefaulter, getAdminDefaulters } from '../Services/User';
import ConfirmationModal from '../Books/Components/ConfirmationModal';
import { useDebounce } from '../../../CustomHooks/DebounceHook';

const ListDefaulters = () => {
    const [confirmationModal, setConfirmationModal] = useState({ show: false, data: null, acceptFx: null, rejectFx: null,message:null });
    const navigate = useNavigate()
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);
    const [defaulters, setDefaulters] = useState([]);
    const [totalDefaulters, setTotalDefaulters] = useState(0);
    const [pagination, setPagination] = useState({ limit: 10, start_from: 0, search: null, order_by: [{ column: 'defaulters.id', order: 'desc' }] });
    const debouncedSearch = useDebounce(search,500);

    const selectFilter = (filter, data) => {
        if (filter === "order") {
            setPagination({ ...pagination, order_by: [data] })
        }
        else if (filter === "pagination") {
            setPagination({ ...pagination, start_from: data })
        }
        else if (filter === "search") {
            setPagination({ ...pagination, start_from: 0, search: data && data.length ? data.trim() : null })
        }
    }

    const getInitialPageData = async () => {
        setLoading(true)
        const result = await getAdminDefaulters({ ...pagination, total_count_of: "defaulters.id" });
        setDefaulters(result.data.defaulters)
        setTotalDefaulters(result.data.totalDefaulterRecords)
        setLoading(false)
    }

    const removeDefaulter = async (data) => {
        const { defaulter_id } = data
        setLoading(true)
        const result = await adminRemoveDefaulter({ defaulter_id });
        if (result.success) {
            getInitialPageData()
            toast.success(result.message)
        }
        else {
            toast.error(result.error.message)
        }
        setConfirmationModal({ show: false, data: null, acceptFx: null, rejectFx: null,message:null })
        setLoading(false)
    }

    useEffect(() => {
        getInitialPageData()
    }, [pagination])

    useEffect(()=>{ 
        selectFilter("search",search)
    },[debouncedSearch])

    return (
        <div className="admin-panel-main">
            <div className="panel-row">
                <div className="left">
                    <AdminNavbar></AdminNavbar>
                </div>
                <div className="right">
                    <div className="panel-title-top all-book">
                        <div className="top-left">
                            <h3 className="heading-h3">Defaulters list</h3>
                        </div>
                        <div className="top-right admin-filter">
                            <div className="right-side">
                                <CButton fxToRun={() => { navigate(urlPrefix() + "/admin/defaulters/insert") }} label="Add Defaulter" custClassName="login-button t-btn"></CButton>
                            </div>
                        </div>
                    </div>

                    <div className="dash-filter filter">
                        <div className="left-fil" />
                        <div className="search">
                            <InputGroup className="admin-search-input" onChange={(e) => setSearch(e.target.value)} >
                                <Form.Control placeholder="Search User name" value={search || ""} />
                            </InputGroup>
                        </div>
                    </div>

                    <div className="admin-panel-data list-defaulter">
                        <div className="top-title all-plans">
                            <div className="order-no">
                                <p className="top-t">Name</p>
                            </div>
                            <div className="title">
                                <p className="top-t">Email</p>
                            </div>
                            <div className="e-status">
                                <p className="top-t">Note</p>
                            </div>
                            <div className="e-edit-delete">
                                <p className="top-t">Actions</p>
                            </div>
                        </div>
                        <div className="book-list">
                            {
                                defaulters && defaulters.length ?
                                    defaulters.map((defaulter) => <div className="book-row all-plans" key={defaulter.defaulter_id}>
                                        <div className="order-no-value">
                                            <p className="top-value">{defaulter.first_name} {defaulter.last_name}</p>
                                        </div>
                                        <div className="title-value">
                                            <p className="top-value">{defaulter.email}</p>
                                        </div>
                                        <div className="title-value">
                                            <p className="top-value">{defaulter.note}</p>
                                        </div>
                                        <div className="e-edit-delete-value">
                                            <a className="edit-action" onClick={() => setConfirmationModal({
                                                show: true,
                                                data: { defaulter_id: defaulter.defaulter_id },
                                                message:"Are you sure you want to delete defaulter ?",
                                                acceptFx: removeDefaulter,
                                                rejectFx: () => { setConfirmationModal({ show: false, data: null, acceptFx: null, rejectFx: null, message:null}) }
                                            })}><img src={urlPrefix() + "/assets/image/trash.svg"} alt='book-image' /></a>
                                        </div>
                                    </div>) :
                                    <div className='no-data'>
                                        No Defaulters found.
                                    </div>
                            }
                            {
                                defaulters && defaulters.length ?
                                    <div className="books-pagination">
                                        <MakePagination totalRecords={totalDefaulters} limiter={10} selectFilter={selectFilter}></MakePagination>
                                    </div>
                                    : null
                            }
                        </div>
                    </div>
                </div>
            </div>
            {
                loading ? <Loading /> : null
            }
            <ConfirmationModal confirmationModal={confirmationModal} />
        </div>
    )
}

export default ListDefaulters
